/**
 * @file loading-state.js
 * @description Estado de carregamento padrão de tabelas e formulários (spinner e texto lado a lado).
 */

import React from "react"
import { Loader } from "lucide-react"
import { cn } from "../../../../lib/utils.js"

/** Estado de carregamento padrão de tabelas e formulários (spinner e texto lado a lado). */
export function LoadingState({ message, className }) {
  return React.createElement(
    "div",
    { className: cn("flex items-center justify-center py-12", className) },
    React.createElement(Loader, { className: "h-6 w-6 animate-spin text-blue-600" }),
    message && React.createElement("span", { className: "ml-2 text-sm text-gray-500" }, message)
  )
}
